/**
 *
 * @todo Explore ways to sort without removing
 * as currently UX-wise it looks bad when it
 * flashes due to the removes.
 *
 */
export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};

export const updatePriorities = (preferences) => {
  for (var i = 0; i < preferences.length; i++) {
    let preference = preferences[i];
    preference.priority = i;
  }

  return preferences;
};

/* 
  Handle key event for different browsers 
  https://unixpapa.com/js/key.html
  */
export const getKeyForBrowser = (event) => {
  let key = event.which ? event.which : event.keyCode;
  if (!key) {
    if (event.charCode) {
      key = event.charCode;
    }
  }

  return key;
};

export const mergedKanbanColumnsAndCards = (columns, cards, kanbanId) => {
  for (var i = 0; i < columns.length; i++) {
    let column = columns[i];
    column.cards = [];
    for (var j = 0; j < cards.length; j++) {
      let card = cards[j];
      for (var k = 0; k < card.lists.length; k++) {
        let cardParentList = card.lists[k];
        if (cardParentList.listId == column._id) {
          column.cards.push(card);
        }
      }
    }
    column.cards.sort(function(a, b) {
      let cardAIndex = null;
      let cardBIndex = null;
      for (var x = 0; x < a.lists.length; x++) {
        let list = a.lists[x];
        if (list.kanbanId == kanbanId && list.listId == column._id) {
          cardAIndex = list.listIndex;
        }
      }
      for (var y = 0; y < b.lists.length; y++) {
        let list = b.lists[y];
        if (list.kanbanId == kanbanId && list.listId == column._id) {
          cardBIndex = list.listIndex;
        }
      }
      return cardAIndex - cardBIndex;
    });
  }
  return columns;
};
